import { ApiClient } from "@/api/shared/api-client";
import type {
  CreateCredentialPayload,
  Credential,
  UpdateCredentialPayload,
} from "@/features/credentials/models/credential";
import type { ApiResponse } from "@/models/api-response";

export class CredentialsClient extends ApiClient {
  public getCredentialsList({
    productToken,
    sport,
    organizationId,
    limit = 6000,
  }: {
    productToken: string;
    sport: string;
    organizationId: string;
    limit?: number;
  }): Promise<ApiResponse<Credential[]>> {
    return this.get<Credential[]>({
      url: `/v1/${sport}/organizations/${organizationId}/credentials`,
      params: { limit },
      headers: {
        Authorization: `Bearer ${productToken}`,
      },
    });
  }

  public createCredential({
    productToken,
    sport,
    organizationId,
    payload,
  }: {
    productToken: string;
    sport: string;
    organizationId: string;
    payload: CreateCredentialPayload;
  }): Promise<ApiResponse<{ success: boolean }>> {
    return this.post<{ success: boolean }>({
      url: `/v1/${sport}/organizations/${organizationId}/credentials`,
      data: payload,
      headers: {
        Authorization: `Bearer ${productToken}`,
      },
    });
  }

  public updateCredential({
    productToken,
    sport,
    organizationId,
    credentialId,
    payload,
  }: {
    productToken: string;
    sport: string;
    organizationId: string;
    credentialId: string;
    payload: UpdateCredentialPayload;
  }): Promise<ApiResponse<{ success: boolean }>> {
    return this.put<{ success: boolean }>({
      url: `/v1/${sport}/organizations/${organizationId}/credentials/${credentialId}`,
      data: payload,
      headers: {
        Authorization: `Bearer ${productToken}`,
      },
    });
  }

  public deleteCredential({
    productToken,
    sport,
    organizationId,
    credentialId,
  }: {
    productToken: string;
    sport: string;
    organizationId: string;
    credentialId: string;
  }): Promise<ApiResponse<{ success: boolean }>> {
    return this.delete<{ success: boolean }>({
      url: `/v1/${sport}/organizations/${organizationId}/credentials/${credentialId}`,
      headers: {
        Authorization: `Bearer ${productToken}`,
      },
    });
  }
}
